import axios from 'axios'

/**
 * @desc Fetches Freight MOV, FFV & Additional cost per carton
 * @desc fetchFreightRateRule in BFF
 */
export const fetchFreightInfo = (supplierId) =>
  axios
    .get(`/authenticated/supplier/${supplierId}/freight-rate-rule`)
    .then((res) => res.data)

/**
 * @desc Fetches Previous Freight MOV, FFV & Additional cost per carton
 * @desc fetchFreightRateRulePrevious in BFF
 */
export const fetchFreightInfoPrevious = (supplierId) =>
  axios
    .get(`/authenticated/supplier/${supplierId}/freight-rate-rule/previous`)
    .then((res) => res.data)

/**
 * @desc Validates that the given values requested to create/edit a suppliers freight rate rules are valid given other
 * elements in the platform that rely upon them (only coupons on the time of writing this)
 * @desc validateAddOrEditFreightRateRule in BFF
 */
export const validateUpdateFreightInfo = (supplierId, request) =>
  axios
    .post(
      `/authenticated/supplier/${supplierId}/freight-rate-rule/valid`,
      request
    )
    .then((res) => res.data)

/**
 * @desc Updates Freight MOV, FFV & Additional cost per carton
 * @desc addOrEditFreightRateRule in BFF
 */
export const updateFreightInfo = (supplierId, request) =>
  axios
    .post(`/authenticated/supplier/${supplierId}/freight-rate-rule`, request)
    .then((res) => res.data)

export const deleteUpcomingFreightInfo = (supplierId) =>
  axios
    .delete(`/authenticated/supplier/${supplierId}/freight-rate-rule`)
    .then((res) => res.data)
